import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { AnimationOnScroll } from 'react-animation-on-scroll'
import CoverW from "../images/projects/w_2.inline.svg"
import CoverC from "../images/projects/c3.inline.svg"
import CoverM from "../images/projects/m2.inline.svg"
import CoverU from "../images/projects/u2.inline.svg"
import CoverT from "../images/projects/t2.inline.svg"
import PPIcon from "../images/icons/pp.inline.svg"
import WIcon from "../images/icons/w.inline.svg"
import CWIcon from "../images/icons/cw.inline.svg"
import UUIcon from "../images/icons/uula.inline.svg"
import TWIcon from "../images/icons/tw.inline.svg"
import SIcon from "../images/icons/s.inline.svg"
import od from "../images/pp/cover_od_v2.png"
import mobile from "../images/pp/cover_mobile_v2.png"
import pam from "../images/pp/pam_v2.png"
import rebrand from "../images/pp/rebrand.gif"
import Tags from "../components/tags"

const Projects = ({type}) => {
  return (
    <AnimationOnScroll animateIn="animate__wrapInUp" animateOnce="true" offset={0}>
      <ul className={"sub-projects " + type}>
        <li>
          <Link className="cover-textpay pp-cover" to="/projects/premium-parking/textpay">
            <div className="pp-info">
              <div className="project-title"><PPIcon className='project-icon white-icon' /> Premium Parking</div>
              <strong>Rethinking checkout flow for add-ons in TextPay and CameraPay</strong>
              Increased revenue up to 20%, added 5 integrations, increased loyal users up to 12%
              <Tags list={['Travel', 'Insurance', 'Growth', 'Product Design']} />
            </div>
            <StaticImage
              placeholder="blurred"
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../images/pp/cover_textpay_v2.png"
              alt="2021-2022. Apply the new brand and successful experiments from other products."
              className="cover"
            />
          </Link>
        </li>
        {type !== 'compact' ? <li>
          <Link to="/projects/premium-parking/od" className="pp-cover cover-od">
            <div className="pp-info">
              <div className="project-title"><PPIcon className='project-icon' /> Premium Parking</div>
              <strong>Shifting the responsibility from operators to the parking lots owners</strong>
              Research and conceptualize a new IA prioritized by user roles
              <Tags list={['B2B','Strategy', 'Product Design']} />
            </div>
            <img src={od} alt="2021. Research and conceptualize a new IA prioritized by user roles." className="cover"/>
          </Link>
        </li> : ''}
        <li>
          <Link to="/projects/premium-parking/mobile" className="pp-cover cover-mobile">
            <div className="pp-info">
              <div className="project-title"><PPIcon className='project-icon white-icon' /> Premium Parking</div>
              <strong>Polishing the parking purchase funnel in Premium Parking mobile apps</strong>
              Improved conversion by +5.68%, and designed new onboarding, map screens, and design system for mobile apps. DAU increased by 2 times.
              <Tags list={['B2C', 'Mobile Apps', 'Conversion Rate Optimization']} />
            </div>
            <img src={mobile} alt="2018-2019. Rethink the checkout flow and whole architecture to support growth" className="cover" />
          </Link>
        </li>
        {type !== 'compact' ? <><li>
          <Link className="pp-cover cover-magicbook" to="/projects/magicbook">
            <div className="pp-info">
              <div className="project-title"><SIcon className='project-icon' /> ScanCafe</div>
              <strong>Improving workflow between design teams</strong>
              Successfully launched products to new markets, along with whitelabel products.
              <Tags list={['B2C', 'AI', 'Mobile Apps', 'Design Management']} />
            </div>
            <CoverM className='cover' />
          </Link>
        </li>
        <li><Link className="pp-cover cover-twiage" to="/projects/twiage">
            <div className="pp-info">
              <div className="project-title"><TWIcon className='project-icon white-icon' /> Twiage</div>
              <strong>Designinging the broadcast messaging for hospitals</strong>
              Emergency Department door-to-room time has decreased by 60%.
              <Tags list={['Healthtech', 'Product Design']} />
            </div>
            <CoverT className='cover' />
          </Link>
        </li></> : ''}
        <li>
          <Link className="pp-cover cover-westwood" to="/projects/wwgeg">
            <div className="pp-info">
              <div className="project-title"><WIcon className='project-icon' /> Westwood Global Energy Group</div>
              <strong>Designing a consistent experience across 5 products</strong>
              Reduced complaints related to confusion with the product up to 20%, shortered design and development time up to 30%
              <Tags list={['Energy', 'Product Design', 'Design System']} />
            </div>
            <CoverW className='cover' />
          </Link>
        </li>
        <li>
          <Link to="/projects/premium-parking/rebrand" className="pp-cover cover-rebrand">
            <div className="pp-info">
              <div className="project-title"><PPIcon className='project-icon' /> Premium Parking</div>
              <strong>A full rebrand of Premium Parking, including the design system</strong>
              Added 5 integrations, shortered design and development time up to 20%
              <Tags list={['Branding', 'Product Design', 'Design System']} />
            </div>
            <img src={rebrand} alt="2019-2020. A full rebrand of Premium Parking, including a new, accessible the design system" className="cover cover-rebrand" />
          </Link>
        </li>

        {type !== 'compact' ? <><li>
          <Link className="pp-cover cover-uula" to="/projects/uula">
            <div className="pp-info">
              <div className="project-title"><UUIcon className='project-icon'/> UULA</div>
              <strong>Designing an engaging learning experience for teenagers and students</strong>
              Over 30% users transitioned to the iOS app in the first months after launch.
              <Tags list={['EdTech', 'Zero → One', 'Design Leadership', 'Product Design']} />
            </div>
            <CoverU className='cover' />
          </Link>
        </li>
        <li>
          <Link to="/projects/premium-parking/pam" className="pp-cover cover-pam">
            <div className="pp-info">
              <div className="project-title"><PPIcon className='project-icon white-icon' /> Premium Parking</div>
              <strong>The transitioning of a usage-based revenue model to SaaS model with data-driven design approach</strong>
              The number of markets increased by 4 times, and the number of parkings increased by 6 times
              <Tags list={['SaaS', 'B2B', 'Zero → One', 'Product Design']} />
            </div>
            <div className="pam-img">
              <img src={pam} alt="2017-2018. Give Parking owners the tools they need to accurately and easily manage 
            their business" className="cover" />
            </div>
          </Link>
        </li>
        <li>
          <Link className="pp-cover cover-clubworx" to="/projects/clubworx">
            <div className="pp-info">
              <div className="project-title"><CWIcon className='project-icon' /> Clubworx</div>
              <strong>Conceiving and designing the entire product lineup while successfully identifying the product-market fit</strong>
              Multiplied revenue and grew into a stable business.

              <Tags list={['SaaS', 'B2B-B2C', 'Growth', 'Product Design']} />
            </div>
            <CoverC className='cover' />
          </Link>
        </li></> : ''}
      </ul>
      {type === 'compact' ? <Link to="/work/#od" className="more-btn">View More Projects</Link> : ''}
    </AnimationOnScroll>)
}

export default Projects
